import * as yup from 'yup';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';

export const mergeDocumentExtensionMatcher = /\.(jpg|jpeg|pdf|png)$/;
export const isMergeableDocument = (fileName: string) => mergeDocumentExtensionMatcher.test(fileName.toLocaleLowerCase());

export const mergeDocumentSchema = yup.object().shape({
  selectedDocuments: yup
    .array()
    .min(2)
    .required()
    .of(
      yup.object({
        fileName: yup.string().ensure().lowercase().matches(mergeDocumentExtensionMatcher),
      })
    )
    .label('Selected Documents'),
  fileName: yup
    .string()
    .nullable()
    .label('File Name')
    .when('category', {
      is: (category: IDocumentCategory) => category?.isRepeatable,
      then: yup.string().required(),
      otherwise: yup.string().notRequired(),
    }),
  category: yup.mixed<IDocumentCategory>().required().nullable().label('Category'),
});
